import Axios from "axios";

const api = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { "X-Api-Key": process.env.VUE_APP_API_KEY },
  timeout: 60000,
});

export default api;
